module.exports = __webpack_public_path__ + "static/juniper-berries-f69b6c732fcc79aeb203fffc4ba6b019.png";